// extracted by mini-css-extract-plugin
module.exports = {"ibc":"Denom_ibc__1lA3D"};